const ShopApiUrl = 'https://trainsweateat.myshopify.com/api/graphql';
const ShopApiToken = '3dfe9664eace609ab8a163ce89be4238';
const ShopFileUrl = 'https://cdn.shopify.com/s/files/1/0654/6679/4196/files/';

function searchProductsByType(elem) {
  let type = elem.data('type');
  let model = elem.data('model');
  
  let isProductCard = false;
  if (elem.closest('.product-grid-item').length > 0)
    isProductCard = true;

  if (type != '' && model != '') {
    $.ajax({
      url: ShopApiUrl,
      method: 'POST',
      headers: {
          'X-Shopify-Storefront-Access-Token': ShopApiToken,
          'Content-Type': 'application/graphql',
      },
      data: `query {
        products(first:100, query: "product_type:'` + type + `'"){
          edges {
            node {
              id
              title
              productType
              handle
              totalInventory
              featuredImage {
                altText
                url
              }
              metafield0: metafield(key:"model", namespace: "custom"){
                value
              }
              metafield1: metafield(key:"color", namespace:"custom"){
                value
              }
              metafield2: metafield(key:"color_name", namespace:"custom"){
                value
              }
              variants(first:100){
                edges {
                  node {
                    id
                    availableForSale
                  }
                }
              }
            }
          }
        }
      }`,
    })
    .done(function(data) {
      if (!data.data.products) {
        elem.remove();
      } else {
        let model_test = elem.data('model');
        
        elem.find('.links a').remove();

        
        var edges = data.data.products.edges;
        var j, id, shopifyId, product, title, handle, mColoris, mCouleur, color_handle, product_type, total_inventory, variants, availableForSale, variants_edges;

        for (var i=0; i<edges.length; i++) {
          product = edges[i].node;
          shopifyId = product.id;
          id = shopifyId.split('/').pop();
          title = product.title;
          handle = product.handle;
          product_type = product.productType;
          total_inventory = product.totalInventory;

          availableForSale = false;
          if (total_inventory > 0) {
            availableForSale = true;
          } else if (total_inventory <= 0 && product.variants) {
            variants_edges = product.variants.edges;
            for (var j=0; j<variants_edges.length; j++) {
              variants = variants_edges[j].node;
              if (variants.availableForSale) {
                availableForSale = true;
                break;
              }
            }
          }
          
          if (handle) {
            sHtml = sHtmlMeta = sHtmlMeta2 = sHtmlClass = mColoris = mCouleur = mModel = '';
  
            if (product.metafield0) mModel = product.metafield0.value;
            if (product.metafield1) mCouleur = product.metafield1.value;
            if (product.metafield2) mColoris = product.metafield2.value;

            if (mModel != '' && mModel == model_test) {
              //if (isProductCard) {
                if (mCouleur != '') {
                  sHtmlMeta2 += 'style="background-color:' + mCouleur + '"';
                } else if (mColoris != '') {
                  sHtmlMeta += ' data-color-name="' + mColoris + '"';
                  sHtmlClass += ' load-file-image';
                } else if (product.featuredImage) {
                  sHtmlMeta2 += ` style="background-image:url('${product.featuredImage.url}&width=50')"`;
                }
              /*} else {
                sHtmlMeta2 += ` style="background-image:url('${product.featuredImage.url}&width=50')"`;
              }*/
              
              sHtml = `<a href="/products/${handle}" class="color-variant${sHtmlClass}${handle == elem.data('product-handle') ? ' active' : ''}${!availableForSale ? ' disable' : ''}" title="${title}" ${sHtmlMeta}><span ${sHtmlMeta2}></span></a>`;
              if (!availableForSale) elem.find('.links').append(sHtml);
              else elem.find('.links').prepend(sHtml);
            }
          }
        }
  
       /*  elem.find('.links .color-variant.load-color-image').each(function(i){
          getProductColorImageSrc($(this));
        });*/
        elem.find('.links .color-variant.load-file-image').each(function(i){
          getProductFileImageSrc($(this));
        });
    
        /*$('.color-selector[data-product-type="' + type + '"]:not(.ready)').each(function(){
          $(this).html(elem.html());
          $(this).addClass('ready').show();
        });*/
      }
  
      elem.addClass('ready').show();
      window.dispatchEvent(new Event("resize"));
      //if (elem.closest('.product-item').length > 0) loopSearchProductsByType();
    });
  } else {
    elem.addClass('ready').show();
    window.dispatchEvent(new Event("resize"));
    //if (elem.closest('.product-item').length > 0) loopSearchProductsByType();
  }
}

function getProductColorImageSrc(elem) {
  var id = elem.data("product-id");
  //var decoded = atob(id);
  //var shopifyId = decoded.split("/").pop();
  //var cleanId =  parseInt(shopifyId);
  
  $.ajax({
    url: ShopApiUrl,
    method: 'POST',
    headers: {
        'X-Shopify-Storefront-Access-Token': ShopApiToken,
        'Content-Type': 'application/graphql',
    },
    data: `query {
      product(id: "gid://shopify/Product/` + id + `") {
        id
        metafield(namespace: "custom", key: "color_image") {
          reference {
            ... on MediaImage {
              id
              image {
                originalSrc
              }
            }
          }
        }
      }
    }`,
  })
  .done(function(data) {
    if (data.data.product) {
      shopifyId = data.data.product.id;
      id = shopifyId.split('/').pop();
      src = data.data.product.metafield.reference.image.originalSrc;

      $('.color-selector .color-variant.load-color-image[data-product-id="' + id + '"] span').css({'background-image': 'url("' + src + '")'});
    }
  });
}

function getProductFileImageSrc(elem) {
  var file = elem.data("color-name");
  $('.color-selector .color-variant.load-file-image[data-color-name="' + file + '"] span').css({'background-image': 'url("' + ShopFileUrl + file + '.jpg")'});
}

function loopSearchProductsByType() {
  let elems = $('.color-selector:not(.ready)');
  elems.each(function() {
    searchProductsByType($(this));
  });
}

$(document).ready(function(){
  loopSearchProductsByType();
});

let resizeTimer;
$(window).on('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    var cardWidth = $('.color-selector:eq(0)').width();
    var swatchesWidth = $('.color-selector:eq(0) .links > a:eq(0)').outerWidth(true);
    var swatchesLimit = Math.floor(cardWidth / swatchesWidth) - 1;
    
    $('.color-selector .links > a').show();
    $('.color-selector .links > .more').remove();
    $('.product-grid-item .color-selector').each(function(){
      var total = $(this).find('.links > a').length;
      var diff = total - swatchesLimit;
      if (diff >= 2) {
        var url = $(this).closest('.product__grid__info').find('> a').attr('href');
        
        $(this).find('.links > a').slice(-diff).hide();
        $(this).find('.links').append('<a class="more" href="' + url +'">+' + diff + '</a>');
      }
    });
  }, 200);
});